import React from 'react';
import { formatDate } from '../../../data/utils';

function EventInfo(props) {
    const event = props.event;

    let desc = event.tournamentDesc || '';
    if (desc.trim().length > 0) {
        desc += ' | ';
    }
    desc += formatDate(event.timestamp).formatted;

    return (
        <div className="d-flex align-items-center | mb_10_1_1">
            <div className="d-flex align-items-center event-info | mb_10_1_1_1">
                {/* {!props.isPsv && event.sportRef > 0 &&
                    <span className={`sport-icon sport-img ${iconSportCssClass(event.sportRef, event.sportIcon)}`}></span>
                } */}
                <span className="text-medium grey | mb_10_1_1_1_1">{desc}</span>
            </div>
        </div>
    );
}

export default EventInfo;